import get from 'lodash/get'

export const isNoteDialogOpen = (state, id) => get(state, ['vegetation', 'note', 'open']) && get(state, ['vegetation', 'note', 'id']) === id;
export const isLoadingNote = (state) => get(state, ['vegetation', 'note', 'loading']);
export const getNoteText = (state) => get(state, ['vegetation', 'note', 'text']);
export const getNote = (state) => get(state, ['vegetation', 'note', 'note']);
export const getNoteReason = (state) => get(state, ['vegetation', 'note', 'reason']);
export const getNoteSiteInspectionId = (state) => get(state, ['vegetation', 'note', 'siteInspectionId']);


// WEBPACK FOOTER //
// ./src/modules/vegetation/selectors/note.js